// extracted by mini-css-extract-plugin
export default {"GSTModal":"GSTModal_GSTModal__WbD6O","Heading":"GSTModal_Heading__XbZYQ"};